import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _WorkActivityGroupUser } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    idGroup: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectWorkActivityGroupUserByIDAccount = ({ idSelector, idGroup, onChange, label, returnType = "ID" }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityGroupUser);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idGroup) {
            getLista();
        }
    }, [idGroup]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDAccount === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDAccount,
                    label: found.DataBeanProperties.AccountFullName,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1,
            IDGroup: idGroup
        }
        instance.getWorkActivityGroupUserRender(null, null, props).then(
            (resp: any) => {
                if (resp) setLista(resp.List);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDAccount,
        label: item.DataBeanProperties.AccountFullName,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Grupos de Trabajo Disponibles"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Grupo de Trabajo..."
                noOptionsMessage={() => "Sin coincidencias"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
        </div >
    );
};
